const getters = {
  user(state) {
    return state.user;
  },
  userData(state) {
    return state.userData;
  },
  userBankAccounts(state) {
    return state.userBankAccounts;
  },
  users(state) {
    return state.users;
  },
};

export default getters;
